/* eslint-disable */

import Component from 'gia/Component'
import Tabulator from 'tabulator-tables'

export default class AnalyticsTable extends Component {
  constructor(element) {
    super(element)

    //trigger download of data.csv file
    document.getElementById('download-csv').addEventListener('click', () => {
      this.exportCsv()
    })
  }

  init() {
    const loader = document.querySelector('.loader-pencil-content')

    $.ajax({
      url: window.location.origin + '/wp/wp-admin/admin-ajax.php',
      type: 'POST',
      data: {
        action: 'get_analytics',
      },
      success: result => {
        this.createTable(this.transformData(result))

        const mutateAction = (value, data, type, params, component) => {
          return value > 0 ? 'Add' : 'Remove'
        }
        new Tabulator('#logs-table', {
          data: result,
          autoResize: false,
          resizableRows: false,
          resizableColumns: false,
          columnMinWidth: 80,
          pagination: 'local',
          layout: 'fitDataTable',
          paginationSize: 50,
          groupBy: 'post_title',
          paginationSizeSelector: [50, 100, 150, 250],
          columns: [
            { title: 'ID', field: 'id' },
            { title: 'User ID', field: 'userId' },
            { title: 'Business name', field: 'post_title', width: 300 },
            { title: 'Date', field: 'date', width: 200 },
            { title: 'Time', field: 'time', width: 200 },
            {
              title: 'Action',
              field: 'isAdded',
              mutator: mutateAction,
              width: 200,
            },
          ],
        })
      },
      complete: function() {
        loader.style.display = 'none'
      },

      error: function() {
        console.warn('error!!')
      },
    })
  }

  createTable(data) {
    this.table = new Tabulator('#analytics-table', {
      data,
      autoResize: false,
      resizableRows: false,
      resizableColumns: false,
      columnMinWidth: 80,
      pagination: 'local',
      layout: 'fitDataTable',
      paginationSize: 50,
      paginationSizeSelector: [50, 100, 150, 250],
      columns: [
        { title: 'Business name', field: 'post_title' },
        {
          title: 'Number of Favorites',
          field: 'count',
        },
      ],
    })
  }

  transformData(res) {
    let data = []
    res.forEach(r => {
      const found = data.filter(d => d.businessId === r.businessId)[0]
      if (!found) {
        if (r.isAdded === '1') {
          const n = Object.assign({}, r)
          n.count = 1
          data.push(n)
        }
      } else {
        if (r.isAdded === '1') {
          found.count += 1
        } else {
          found.count -= 1
        }
        data = [...data.filter(d => d.businessId !== r.businessId), found]
      }
    })

    return data.filter(d => d.count)
  }

  exportCsv() {
    this.table.download('xlsx', 'data.xlsx', { sheetName: 'My Data' })
  }

  mount() {
    this.init()
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/AnalyticsTable.js